import { render, staticRenderFns } from "./CardsFilter.vue?vue&type=template&id=6c177922"
import script from "./CardsFilter.vue?vue&type=script&lang=ts"
export * from "./CardsFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports